var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmalRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Camada_2",
    "data-name": "Camada 2",
    viewBox: "0 0 344.35 299",
    width: 344.3500061035156,
    height: 299,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e5293f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.63,144.21c-9.56,20.64-16.32,42.57-24.31,63.94,18.03-19.02,39.94-21.02,63.96-21.02h138.41c23.81,0,45.1-14.83,53.35-37.17l13.94-37.72H104.04c-21.09,0-37.65,13.06-46.41,31.98ZM15.43,256.43L0,299h187.47c27.69,0,52.47-17.12,62.15-42.93l11.92-31.79H61.44c-20.61,0-39.01,12.86-46.01,32.16ZM145.42,0c-21.09,0-37.65,13.06-46.41,31.98-9.56,20.64-16.32,42.57-24.31,63.94,18.03-19.02,39.94-21.02,63.96-21.02h138.41c23.81,0,45.1-14.83,53.35-37.17L344.35,0h-198.93Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmalRed);
export default __webpack_public_path__ + "static/media/logoSmalRed.12e32cc0564fdba2a4bf590bd0b3c0c0.svg";
export { ForwardRef as ReactComponent };